import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
import { convertModelToFormData } from '@application/helpers/form-data-helper';
const createVDKEvent = (event) => {
    // Map frontend properties to match backend DTO casing
    const mappedEvent = {
        Title: event.title,
        Location: event.location,
        EventCompanyIds: event.eventCompanyIds,
        BackgroundImages: event.backgroundImages?.map((img) => ({
            Image: img.image,
            IsBackgroundImage: img.isBackgroundImage,
            IsCustomImage: img.isCustomImage
        })),
        StartDate: event.startDate,
        EndDate: event.endDate,
        IsMultiDayEvent: event.isMultiDayEvent,
        StartTime: event.startTime,
        EndTime: event.endTime,
        DueRegistrationDate: event.dueRegistrationDate,
        Status: event.status,
        PostponementReason: event.postponementReason,
        IsExternalAllowed: event.isExternalAllowed,
        NoOfSteps: event.noOfSteps,
        WelcomeText: event.welcomeText,
        ThankYouText: event.thankYouText,
        Details: event.details,
        FloorPlan: event.floorPlan,
        IsPasswordProtection: event.isPasswordProtection,
        Password: event.password,
        FormSteps: event.formSteps,
        ExtraInformations: event.extraInformations?.map((info, index) => ({
            Title: info.title,
            Description: info.description,
            SortOrder: index + 1,
            File: info.file ?? null
        })),
        AssigneeIds: event.assigneeIds,
        CollaboratorIds: event.collaboratorIds,
        Type: event.type,
        DefaultImagesUrl: event.defaultImagesUrl,
        InterestIds: event.interestIds,
        LanguageIds: event.languageIds,
        IsSponsorPartnerExternalEvent: event.isSponsorPartnerExternalEvent,
        IsSponsorPartnerEvent: event.isSponsorPartnerEvent,
        ContactEventTeamEmail: event.contactEventTeamEmail,
        ContactEventTeamPhone: event.contactEventTeamPhone,
    };
    // Convert the mapped event object to FormData using the helper
    const formData = convertModelToFormData(mappedEvent);
    return vdkEmHappinessPortalApi.post('/vdk-events/create', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const updateVDKEvent = (event) => {
    // Map frontend properties to match backend DTO casing
    const mappedEvent = {
        Id: event.id,
        Title: event.title,
        Location: event.location,
        EventCompanyIds: event.eventCompanyIds,
        BackgroundImages: event.backgroundImages?.map((img) => ({
            Image: img.image,
            IsBackgroundImage: img.isBackgroundImage,
            IsCustomImage: img.isCustomImage
        })),
        ExistingImages: event.existingImages?.map((img) => ({
            Id: img.id,
            IsBackgroundImage: img.isBackgroundImage,
            IsCustomImage: img.isCustomImage
        })),
        StartDate: event.startDate,
        EndDate: event.endDate,
        IsMultiDayEvent: event.isMultiDayEvent,
        StartTime: event.startTime,
        EndTime: event.endTime,
        DueRegistrationDate: event.dueRegistrationDate,
        Status: event.status,
        PostponementReason: event.postponementReason,
        IsExternalAllowed: event.isExternalAllowed,
        NoOfSteps: event.noOfSteps,
        WelcomeText: event.welcomeText,
        ThankYouText: event.thankYouText,
        Details: event.details,
        FloorPlan: event.floorPlan,
        IsPasswordProtection: event.isPasswordProtection,
        Password: event.password,
        FormSteps: event.formSteps,
        ExtraInformations: event.extraInformations?.map((info, index) => ({
            Id: info.id,
            Title: info.title,
            Description: info.description,
            SortOrder: index + 1,
            File: info.file ?? null
        })),
        AssigneeIds: event.assigneeIds,
        CollaboratorIds: event.collaboratorIds,
        Type: event.type,
        InterestIds: event.interestIds,
        LanguageIds: event.languageIds,
        languageId: event.languageId,
        IsSponsorPartnerExternalEvent: event.isSponsorPartnerExternalEvent,
        IsSponsorPartnerEvent: event.isSponsorPartnerEvent,
        BenefitType: event.benefitType,
        ContactEventTeamEmail: event.contactEventTeamEmail,
        ContactEventTeamPhone: event.contactEventTeamPhone,
    };
    // Convert the mapped event object to FormData using the helper
    const formData = convertModelToFormData(mappedEvent);
    // Add undertaking files to FormData
    if (event.undertakingFiles && event.undertakingFiles.length > 0) {
        event.undertakingFiles.forEach((file, index) => {
            formData.append(`UndertakingFiles[${index}]`, file);
        });
        // Append languages aligned by index if provided
        if (event.undertakingFilesLanguages && event.undertakingFilesLanguages.length > 0) {
            event.undertakingFilesLanguages.forEach((langId, index) => {
                formData.append(`UndertakingFilesLanguages[${index}]`, langId);
            });
        }
    }
    return vdkEmHappinessPortalApi.post('/vdk-events/update', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Translation-Preview': event.isTranslationPreview ? 'true' : 'false'
        }
    });
};
const getAllVDKEvents = (request) => {
    return vdkEmHappinessPortalApi.post('/VDK-events/get-all', request);
};
const getAllVDKEventsForTask = () => {
    return vdkEmHappinessPortalApi.get('/VDK-events/get-all-for-tasks');
};
const getVDKEventById = async (request) => {
    return await vdkEmHappinessPortalApi.post(`/VDK-events/get-by-id`, request);
};
const deleteVDKEvent = (eventId) => {
    return vdkEmHappinessPortalApi.delete(`/VDK-events/${eventId}`);
};
const LinkVDKEvent = (eventId) => {
    return vdkEmHappinessPortalApi.put(`/VDK-events/link-event/${eventId}`);
};
const getVDKEventByIdForEventDetails = async (request) => {
    return await vdkEmHappinessPortalApi.post(`/VDK-events/get-by-id-for-details`, request);
};
const validateEventPassword = async (request) => {
    return await vdkEmHappinessPortalApi.post('/vdk-events/validate-password', request);
};
const getAllVDKEventSortAndFilter = (request) => {
    return vdkEmHappinessPortalApi.post('/vdk-events/get-all-event-sort-and-filter', request);
};
const updateEventLinkAndPassword = async (request) => {
    return await vdkEmHappinessPortalApi.put('/vdk-events/update-event-link-and-password', request);
};
const getVDKEventByIdForRegistration = async (request) => {
    return await vdkEmHappinessPortalApi.post('/VDK-events/get-by-id-for-registration', request);
};
const getPartnerVDKEvents = async (request) => {
    return await vdkEmHappinessPortalApi.post('/vdk-events/get-partner-events', request);
};
const getUserCountry = () => vdkEmHappinessPortalApi.get('/vdk-events/user-country', {
    timeout: 3000
});
const VDKEventAPI = {
    createVDKEvent,
    updateVDKEvent,
    getAllVDKEvents,
    getVDKEventById,
    deleteVDKEvent,
    getVDKEventByIdForEventDetails,
    validateEventPassword,
    getAllVDKEventSortAndFilter,
    updateEventLinkAndPassword,
    getVDKEventByIdForRegistration,
    getPartnerVDKEvents,
    LinkVDKEvent,
    getAllVDKEventsForTask,
    getUserCountry
};
export default VDKEventAPI;
